import type { AlertRule } from "@/api/queries";
import type { ValueFormat } from "@/artifacts/format";

/** A rule as the sentence after its metric's name: "falls by 15% or more". */
export function describeRule(
  rule: Pick<AlertRule, "condition" | "threshold" | "direction" | "metric_format">,
  format: (value: number, kind: ValueFormat) => string,
) {
  const amount =
    rule.condition === "delta_pct"
      ? `${rule.threshold}%`
      : format(rule.threshold, (rule.metric_format || "number") as ValueFormat);
  if (rule.condition === "above") return `goes above ${amount}`;
  if (rule.condition === "below") return `goes below ${amount}`;
  const verb = rule.direction === "up" ? "rises" : rule.direction === "down" ? "falls" : "moves";
  return `${verb} by ${amount} or more`;
}
